module.exports = __webpack_public_path__ + "static/bewell-logo-42cd7a533bcc4536481e7e691b6be615.png";